import React from 'react';
import styled from 'styled-components';
import nominationForm from '../data/IOLCF-BOD-Nomination-Form.pdf';

const Announcements = styled.div`
    background: ${props => props.theme.gray};
    padding: 40px 24px;

    section {
        max-width: 960px;
        margin: 0 auto;
        padding: 32px 0;
        text-align: center;

        & + section {
            border-top: 1px solid #ddd;
        }
    }

    h2 {
        font-size: 28px;
        line-height: 1.3;
        margin-bottom: 20px;
    }

    p {
        font-size: 18px;
        line-height: 1.7;
    }

    a {
        display: inline-block;
        margin-top: 24px;
        font-weight: 800;
    }

    .download-button {
        background: ${props => props.theme.orange};
        border: 3px solid ${props => props.theme.orange};
        border-radius: 3px;
        color: ${props => props.theme.black};
        padding: 14px 24px;
        text-decoration: none;

        &:hover,
        &:focus {
            background: ${props => props.theme.white};
        }
    }

    @media (max-width: 768px) {
        padding: 16px 20px;

        h2 {
            font-size: 24px;
        }
    }
`;

const HomeAnnouncements = () => (
    <Announcements>
        <section aria-labelledby="board-nominations">
            <h2 id="board-nominations">
                2027–2028 Board of Directors Nominations
            </h2>
            <p>
                <strong>
                    We are now accepting nominations for the 2027–2028 IOLCF
                    Board of Directors! If you are interested in serving or
                    would like to nominate a fellow franchisee, please click
                    below to download the Board of Directors Nomination Form.
                </strong>
            </p>
            <a className="download-button" href={nominationForm} download>
                Download Board of Directors Nomination Form (PDF)
            </a>
        </section>
        <section aria-labelledby="cfa-membership">
            <h2 id="cfa-membership">Coalition of Franchisee Associations</h2>
            <p>
                The Independent Organization of Little Caesar Franchisees
                (IOLCF) is a proud member of the{' '}
                <strong>Coalition of Franchisee Associations (CFA)</strong>,
                joining franchisee associations from across the country to
                advocate for and protect the interests of franchise owners.
                Through the CFA, the IOLCF has a stronger collective voice on
                issues that impact franchisees and the franchise industry.
            </p>
            <a
                href="https://thecfainc.com/about-us/leadership/"
                target="_blank"
                rel="noopener noreferrer"
            >
                Learn more about the CFA
            </a>
        </section>
        <section aria-labelledby="annual-conference">
            <h2 id="annual-conference">2027 IOLCF Annual Conference</h2>
            <p>
                <strong>
                    Mark your calendars! The 2027 IOLCF Annual Conference will
                    be held on Sunday, May 2, 2027. We look forward to bringing
                    our members together for another great conference!
                </strong>
            </p>
        </section>
    </Announcements>
);

export default HomeAnnouncements;
